var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomErrorCard',{attrs:{"mainText":'error.notAllowed'}})
}
var staticRenderFns = []

export { render, staticRenderFns }